export default "__VITE_ASSET__BpcOftiG__"